export default "__VITE_ASSET__BGf$5L4a__"